import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import coursePrimaryActionButtonSE from './locales/exl/sv/coursePrimaryActionButton.json';
import courseDetailsHeaderSV from './locales/exl/sv/courseDetailsHeader.json';
import courseDetailsBodySV from './locales/exl/sv/courseDetailsBody.json';
import generalCourseInformationSV from './locales/exl/sv/generalCourseInformation.json';
import courseDetailsSV from './locales/exl/sv/courseDetails.json';
import courseLecturesSV from './locales/exl/sv/courseLectures.json';
import courseBookingsSV from './locales/exl/sv/courseBookings.json';
import courseModalsSV from './locales/exl/sv/courseModals.json';
import addCourseSV from './locales/exl/sv/addCourse.json';
import certificateModalsSV from './locales/exl/sv/certificateModals.json';
import editCourseSV from './locales/exl/sv/editCourse.json';
import duplicateCourseSV from './locales/exl/sv/duplicateCourse.json';
import courseTableSV from './locales/exl/sv/courseTable.json';
import teacherTableSV from './locales/exl/sv/teacherTable.json';
import errorMessagesSV from './locales/exl/sv/errorMessages.json';
import exlNavMenuSV from './locales/exl/sv/exlNavMenu.json';
import lectureDetailsSV from './locales/exl/sv/lectureDetails.json';
import lectureDetailsHeaderSV from './locales/exl/sv/lectureDetailsHeader.json';
import lectureDetailsBodySV from './locales/exl/sv/lectureDetailsBody.json';
import generalLectureInformationSV from './locales/exl/sv/generalLectureInformation.json';
import lectureAttendanceSV from './locales/exl/sv/lectureAttendance.json';
import teacherDetailsSV from './locales/exl/sv/teacherDetails.json';
import teacherDetailsHeaderSV from './locales/exl/sv/teacherDetailsHeader.json';
import teacherDetailsBodySV from './locales/exl/sv/teacherDetailsBody.json';
import generalTeacherInformationSV from './locales/exl/sv/generalTeacherInformation.json';
import teacherCoursesSV from './locales/exl/sv/teacherCourses.json';
import addLectureSV from './locales/exl/sv/addLecture.json';
import lectureModalsSV from './locales/exl/sv/lectureModals.json';
import editDateTimeSV from './locales/exl/sv/editDateTime.json';
import editLectureSV from './locales/exl/sv/editLecture.json';
import addTeacherSV from './locales/exl/sv/addTeacher.json';
import teacherModalsSV from './locales/exl/sv/teacherModals.json';
import editTeacherSV from './locales/exl/sv/editTeacher.json';
import editCourseBookingsSV from './locales/exl/sv/editCourseBookings.json';
import bookingsListSV from './locales/exl/sv/bookingsList.json';
import editLectureAttendancesSV from './locales/exl/sv/editLectureAttendances.json';
import createReportSV from './locales/exl/sv/createReport.json';
import navMenuSV from './locales/reg/sv/navMenu.json';
import sharedSV from './locales/exl/sv/shared.json';
import coursePrimaryActionButtonEN from './locales/exl/en/coursePrimaryActionButton.json';
import courseDetailsHeaderEN from './locales/exl/en/courseDetailsHeader.json';
import courseDetailsBodyEN from './locales/exl/en/courseDetailsBody.json';
import generalCourseInformationEN from './locales/exl/en/generalCourseInformation.json';
import courseDetailsEN from './locales/exl/en/courseDetails.json';
import courseLecturesEN from './locales/exl/en/courseLectures.json';
import courseBookingsEN from './locales/exl/en/courseBookings.json';
import courseModalsEN from './locales/exl/en/courseModals.json';
import addCourseEN from './locales/exl/en/addCourse.json';
import certificateModalsEN from './locales/exl/en/certificateModals.json';
import editCourseEN from './locales/exl/en/editCourse.json';
import duplicateCourseEN from './locales/exl/en/duplicateCourse.json';
import courseTableEN from './locales/exl/en/courseTable.json';
import teacherTableEN from './locales/exl/en/teacherTable.json';
import errorMessagesEN from './locales/exl/en/errorMessages.json';
import exlNavMenuEN from './locales/exl/en/exlNavMenu.json';
import lectureDetailsEN from './locales/exl/en/lectureDetails.json';
import lectureDetailsHeaderEN from './locales/exl/en/lectureDetailsHeader.json';
import lectureDetailsBodyEN from './locales/exl/en/lectureDetailsBody.json';
import generalLectureInformationEN from './locales/exl/en/generalLectureInformation.json';
import lectureAttendanceEN from './locales/exl/en/lectureAttendance.json';
import teacherDetailsEN from './locales/exl/en/teacherDetails.json';
import teacherDetailsHeaderEN from './locales/exl/en/teacherDetailsHeader.json';
import teacherDetailsBodyEN from './locales/exl/en/teacherDetailsBody.json';
import generalTeacherInformationEN from './locales/exl/en/generalTeacherInformation.json';
import teacherCoursesEN from './locales/exl/en/teacherCourses.json';
import addLectureEN from './locales/exl/en/addLecture.json';
import lectureModalsEN from './locales/exl/en/lectureModals.json';
import editDateTimeEN from './locales/exl/en/editDateTime.json';
import editLectureEN from './locales/exl/en/editLecture.json';
import addTeacherEN from './locales/exl/en/addTeacher.json';
import teacherModalsEN from './locales/exl/en/teacherModals.json';
import editTeacherEN from './locales/exl/en/editTeacher.json';
import editCourseBookingsEN from './locales/exl/en/editCourseBookings.json';
import bookingsListEN from './locales/exl/en/bookingsList.json';
import editLectureAttendancesEN from './locales/exl/en/editLectureAttendances.json';
import createReportEN from './locales/exl/en/createReport.json';
import sharedEN from './locales/exl/en/shared.json';
import employeeTableSV from './locales/reg/sv/employeeTable.json';
import employeeTableEN from './locales/reg/en/employeeTable.json';
import navMenuEN from './locales/reg/en/navMenu.json';
import employeeDetailsSV from './locales/reg/sv/employeeDetails.json';
import employeeDetailsEN from './locales/reg/en/employeeDetails.json';
import customerTableSV from './locales/reg/sv/customerTable.json';
import customerTableEN from './locales/reg/en/customerTable.json';
import customerInvoiceInfoSV from './locales/reg/sv/customerInvoiceInfo.json';
import customerInvoiceInfoEN from './locales/reg/en/customerInvoiceInfo.json';
import customerDetailsSV from './locales/reg/sv/customerDetails.json';
import customerDetailsEN from './locales/reg/en/customerDetails.json';
import officeTableSV from './locales/reg/sv/officeTable.json';
import officeTableEN from './locales/reg/en/officeTable.json';
import officeDetailsSV from './locales/reg/sv/officeDetails.json';
import officeDetailsEN from './locales/reg/en/officeDetails.json';
import coveringTableSV from './locales/reg/sv/coveringTable.json';
import coveringTableEN from './locales/reg/en/coveringTable.json';
import detailContentSV from './locales/crm/sv/detailContent.json';
import detailContentEN from './locales/crm/en/detailContent.json';
import dealDetailsSV from './locales/crm/sv/dealDetails.json';
import dealDetailsEN from './locales/crm/en/dealDetails.json';
import removeContentSV from './locales/crm/sv/removeContent.json';
import removeContentEN from './locales/crm/en/removeContent.json';
import organizationDetailsSV from './locales/crm/sv/organizationDetails.json';
import organizationDetailsEN from './locales/crm/en/organizationDetails.json';
import historyItemsSV from './locales/crm/sv/historyItems.json';
import historyItemsEN from './locales/crm/en/historyItems.json';
import itemDetailsSV from './locales/crm/sv/itemDetails.json';
import itemDetailsEN from './locales/crm/en/itemDetails.json';
import crmNavMenuDropDownSV from './locales/crm/sv/crmNavMenuDropDown.json';
import crmNavMenuDropDownEN from './locales/crm/en/crmNavMenuDropDown.json';
import dealFilterDropDownSV from './locales/crm/sv/dealFilterDropDown.json';
import dealFilterDropDownEN from './locales/crm/en/dealFilterDropDown.json';
import EditBooleanEN from './locales/crm/en/editBoolean.json';
import EditBooleanSV from './locales/crm/sv/editBoolean.json';
import addDealEN from './locales/crm/en/addDeal.json';
import addDealSV from './locales/crm/sv/addDeal.json';

const resources = {
    sv: {
        coursePrimaryActionButton: coursePrimaryActionButtonSE,
        courseDetailsHeader: courseDetailsHeaderSV,
        courseDetailsBody: courseDetailsBodySV,
        generalCourseInformation: generalCourseInformationSV,
        courseDetails: courseDetailsSV,
        courseLectures: courseLecturesSV,
        courseBookings: courseBookingsSV,
        courseModals: courseModalsSV,
        addCourse: addCourseSV,
        editCourse: editCourseSV,
        duplicateCourse: duplicateCourseSV,
        courseTable: courseTableSV,
        teacherTable: teacherTableSV,
        errorMessages: errorMessagesSV,
        exlNavMenu: exlNavMenuSV,
        lectureDetails: lectureDetailsSV,
        lectureDetailsHeader: lectureDetailsHeaderSV,
        lectureDetailsBody: lectureDetailsBodySV,
        generalLectureInformation: generalLectureInformationSV,
        lectureAttendance: lectureAttendanceSV,
        teacherDetails: teacherDetailsSV,
        teacherDetailsHeader: teacherDetailsHeaderSV,
        teacherDetailsBody: teacherDetailsBodySV,
        generalTeacherInformation: generalTeacherInformationSV,
        teacherCourses: teacherCoursesSV,
        addLecture: addLectureSV,
        lectureModals: lectureModalsSV,
        editDateTime: editDateTimeSV,
        editLecture: editLectureSV,
        addTeacher: addTeacherSV,
        teacherModals: teacherModalsSV,
        editTeacher: editTeacherSV,
        editCourseBookings: editCourseBookingsSV,
        bookingsList: bookingsListSV,
        editLectureAttendances: editLectureAttendancesSV,
        createReport: createReportSV,
        shared: sharedSV,
        employeeTable: employeeTableSV,
        navMenu: navMenuSV,
        employeeDetails: employeeDetailsSV,
        customerTable: customerTableSV,
        customerInvoiceInfo: customerInvoiceInfoSV,
        customerDetails: customerDetailsSV,
        officeTable: officeTableSV,
        officeDetails: officeDetailsSV,
        coveringTable: coveringTableSV,
        detailContent: detailContentSV,
        dealDetails: dealDetailsSV,
        removeContent: removeContentSV,
        organizationDetails: organizationDetailsSV,
        historyItems: historyItemsSV,
        itemDetails: itemDetailsSV,
        crmNavMenuDropDown: crmNavMenuDropDownSV,
        dealFilterDropDown: dealFilterDropDownSV,
        editBoolean: EditBooleanSV,
        addDeal: addDealSV,
        certificateModals: certificateModalsSV,
    },
    en: {
        coursePrimaryActionButton: coursePrimaryActionButtonEN,
        courseDetailsHeader: courseDetailsHeaderEN,
        courseDetailsBody: courseDetailsBodyEN,
        generalCourseInformation: generalCourseInformationEN,
        courseDetails: courseDetailsEN,
        courseLectures: courseLecturesEN,
        courseBookings: courseBookingsEN,
        courseModals: courseModalsEN,
        addCourse: addCourseEN,
        editCourse: editCourseEN,
        duplicateCourse: duplicateCourseEN,
        courseTable: courseTableEN,
        teacherTable: teacherTableEN,
        errorMessages: errorMessagesEN,
        exlNavMenu: exlNavMenuEN,
        lectureDetails: lectureDetailsEN,
        lectureDetailsHeader: lectureDetailsHeaderEN,
        lectureDetailsBody: lectureDetailsBodyEN,
        generalLectureInformation: generalLectureInformationEN,
        lectureAttendance: lectureAttendanceEN,
        teacherDetails: teacherDetailsEN,
        teacherDetailsHeader: teacherDetailsHeaderEN,
        teacherDetailsBody: teacherDetailsBodyEN,
        generalTeacherInformation: generalTeacherInformationEN,
        teacherCourses: teacherCoursesEN,
        addLecture: addLectureEN,
        lectureModals: lectureModalsEN,
        editDateTime: editDateTimeEN,
        editLecture: editLectureEN,
        addTeacher: addTeacherEN,
        teacherModals: teacherModalsEN,
        editTeacher: editTeacherEN,
        editCourseBookings: editCourseBookingsEN,
        bookingsList: bookingsListEN,
        editLectureAttendances: editLectureAttendancesEN,
        createReport: createReportEN,
        shared: sharedEN,
        employeeTable: employeeTableEN,
        navMenu: navMenuEN,
        employeeDetails: employeeDetailsEN,
        customerTable: customerTableEN,
        customerInvoiceInfo: customerInvoiceInfoEN,
        customerDetails: customerDetailsEN,
        officeTable: officeTableEN,
        officeDetails: officeDetailsEN,
        coveringTable: coveringTableEN,
        detailContent: detailContentEN,
        dealDetails: dealDetailsEN,
        removeContent: removeContentEN,
        organizationDetails: organizationDetailsEN,
        historyItems: historyItemsEN,
        itemDetails: itemDetailsEN,
        crmNavMenuDropDown: crmNavMenuDropDownEN,
        dealFilterDropDown: dealFilterDropDownEN,
        editBoolean: EditBooleanEN,
        addDeal: addDealEN,
        certificateModals: certificateModalsEN,
    }
};

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: localStorage.getItem('userLocale')?.toLowerCase() ?? "en",
    resources,
    ns: ['coursePrimaryActionButton',
        'courseDetailsHeader',
        'courseDetailsBody',
        'generalCourseInformation',
        'courseLectures',
        'courseBookings',
        'courseModals',
        'addCourse',
        'editCourse',
        'duplicateCourse',
        'courseTable',
        'teacherTable',
        'shared',
        'errorMessages',
        'exlNavMenu',
        'lectureDetails',
        'lectureDetailsHeader',
        'lectureDetailsBody',
        'generalLectureInformation',
        'lectureAttendance',
        'teacherDetails',
        'teacherDetailsHeader',
        'teacherDetailsBody',
        'generalTeacherInformation',
        'teacherCourses',
        'addLecture',
        'lectureModals',
        'editDateTime',
        'editLecture',
        'addTeacher',
        'teacherModals',
        'editTecher',
        'editCourseBookings',
        'bookingsList',
        'createReport',
        'employeeTable',
        'navMenu',
        'employeeDetails',
        'customerTable',
        'customerInvoiceInfo',
        'customerDetails',
        'officeTable',
        'officeDetails',
        'detailContent',
        'dealDetails',
        'organizationDetails',
        'removeContent',
        'historyItems',
        'itemDetails',
        'crmNavMenuDropDown',
        'dealFilterDropDown',
        'editBoolean',
        'addDeal',
        'addCertificate',
        'certificateModals',
    ],
    defaultNS: 'shared'
});

i18n.languages = ['sv', 'en'];

export default i18n;